import { createSelector } from 'reselect';

const allViewMenu = state => state.auth.config.menus;

const filterMenus = (menus, location = 'header') => {
  if (location === 'profile') {
    return menus.filter(ea => ea.displaytype === 'menuProfile');
  }
  return menus.filter(ea => ea.displaytype !== 'menuProfile');
};

export const getHeaderMenu = createSelector(
  allViewMenu,
  menus => filterMenus(menus, 'header')
);

export const getProfileMenu = createSelector(
  allViewMenu,
  menus => filterMenus(menus, 'profile')
);



// WEBPACK FOOTER //
// ./src/layouts/selector.js